<template>
    <div id="aia_tabmenu">
        <div id="aia_tabmenu_wrapper">
            <div class="aia-tabmenu-item"
                :class="[{'aia-tabmenu-item-active': pageName == 'home'}, {'tabmenu-prestige': tier != 'm'}]"
                @click="clickMenu('home')">
                <div class="aia-tabmenu-img">
                    <div class="seperate-bar"></div>
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid img-sharpen" v-if="pageName == 'home'" src="@/components/Layout/footer/asset/prestige/prestige-privilege-active@3x-en.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'home'" src="@/components/Layout/footer/asset/prestige/prestige-privilege-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid img-sharpen" v-if="pageName == 'home'" src="@/components/Layout/footer/asset/prestige/prestige-privilege-active@3x.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'home'" src="@/components/Layout/footer/asset/prestige/prestige-privilege-inactive@3x.png" />
                    </template>
                </div>
            </div>
            <div class="aia-tabmenu-item"
                :class="[{'aia-tabmenu-item-active': pageName == 'history'}, {'tabmenu-prestige': tier != 'm'}]"
                @click="clickMenu('history')">
                <div class="aia-tabmenu-img">
                    <div class="seperate-bar"></div>
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid img-sharpen" v-if="pageName == 'history'" src="@/components/Layout/footer/asset/prestige/prestige-coupon-active@3x-en.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'history'" src="@/components/Layout/footer/asset/prestige/prestige-coupon-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid img-sharpen" v-if="pageName == 'history'" src="@/components/Layout/footer/asset/prestige/prestige-coupon-active@3x.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'history'" src="@/components/Layout/footer/asset/prestige/prestige-coupon-inactive@3x.png" />
                    </template>
                </div>
            </div>
            <div class="aia-tabmenu-item"
                :class="[{'aia-tabmenu-item-active': pageName == 'about'}, {'tabmenu-prestige': tier != 'm'}]"
                @click="clickMenu('about')">
                <div class="aia-tabmenu-img">
                    <div class="seperate-bar" v-if="tier != 'm'"></div>
                    <template v-if="localeCode == 1033">
                        <img class="img-fluid img-sharpen" v-if="pageName == 'about'" src="@/components/Layout/footer/asset/prestige/prestige-about-active@3x-en.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'about'" src="@/components/Layout/footer/asset/prestige/prestige-about-inactive@3x-en.png" />
                    </template>
                    <template v-else>
                        <img class="img-fluid img-sharpen" v-if="pageName == 'about'" src="@/components/Layout/footer/asset/prestige/prestige-about-active@3x.png" />
                        <img class="img-fluid img-sharpen" v-if="pageName != 'about'" src="@/components/Layout/footer/asset/prestige/prestige-about-inactive@3x.png" />
                    </template>
                </div>
            </div>
            <div class="aia-tabmenu-item"
                :class="[{'aia-tabmenu-item-active': pageName == 'profile'}, {'tabmenu-prestige': tier != 'm'}]"
                v-if="tier != 'm'"
                @click="clickMenu('profile')">
                <template v-if="localeCode == 1033">
                    <div class="aia-tabmenu-img-profile">
                    <img class="img-fluid img-sharpen" v-if="pageName == 'profile'" src="@/components/Layout/footer/asset/prestige/prestige-profile-active@3x-en.png" />
                    <img class="img-fluid img-sharpen" v-if="pageName != 'profile'" src="@/components/Layout/footer/asset/prestige/prestige-profile-inactive@3x-en.png" />
                </div>
                </template>
                <template v-else>
                    <div class="aia-tabmenu-img">
                    <img class="img-fluid img-sharpen" v-if="pageName == 'profile'" src="@/components/Layout/footer/asset/prestige/prestige-profile-active@3x.png" />
                    <img class="img-fluid img-sharpen" v-if="pageName != 'profile'" src="@/components/Layout/footer/asset/prestige/prestige-profile-inactive@3x.png" />
                </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Locale from "@/helper/locale/locale.js";
export default {
    name: 'PrestigeFootMenu',
    computed: {
        tier: function () {
            return this.$store.state.tier;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        pageName: String
    },
    data: function () {
        return {
            trackingService: new TrackingService(this),
            localeCode: Locale.getLocaleCode(),
        };
    },
    methods: {
        clickMenu: function(page) {
            this.bzbTracking(page)
            var path = `/${page}`;
            if (page == 'history') path += "/burn"
            this.$router.push(path);
        },
        bzbTracking: function(type) {
            var trackingEventCategory = ''
            var eventName = ''
            switch(type) {
                case 'home':
                    trackingEventCategory = 'homepage_list'
                    eventName = 'click_homepage'
                    break;
                case 'about':
                    trackingEventCategory = 'about_us'
                    eventName = 'click_about_us'
                    break;
            }
            this.trackingService.event(trackingEventCategory, eventName, null, null)
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#aia_tabmenu {
    background-color: $prestige_theme_color;

    #aia_tabmenu_wrapper .aia-tabmenu-item-active {
        background: rgb(51,61,71);
        background: -moz-linear-gradient(90deg, rgba(51,61,71,1) 0%, rgba(132,138,144,1) 50%, rgba(51,61,71,1) 100%);
        background: -webkit-linear-gradient(90deg, rgba(51,61,71,1) 0%, rgba(132,138,144,1) 50%, rgba(51,61,71,1) 100%);
        background: linear-gradient(90deg, rgba(51,61,71,1) 0%, rgba(132,138,144,1) 50%, rgba(51,61,71,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#333d47",endColorstr="#333d47",GradientType=1);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
}
</style>
